import {Match} from '@shared/models/match';

export class FanModeratorStatusType {
  static readonly IMMEDIATE  = new FanModeratorStatusType('IMMEDIATE', 'immediately');
  static readonly OPEN  = new FanModeratorStatusType('OPEN', 'open');
  static readonly REGISTERED  = new FanModeratorStatusType('REGISTERED', 'registered');

  static readonly types: FanModeratorStatusType[] = [
    FanModeratorStatusType.IMMEDIATE,
    FanModeratorStatusType.OPEN,
    FanModeratorStatusType.REGISTERED
  ];

  static fromValue(value: string): FanModeratorStatusType {
    for (let i = 0; i < this.types.length; i++) {
      if (this.types[i].value === value) {
        return this.types[i];
      }
    }
  }

  // private to disallow creating other instances of this type
  private constructor(private readonly key: string, public readonly value: any) {}
}



export class FanModerator {
  status: string;
  moderatorid: string;
  registrations: any[];
  registration_timestamps: {open: number, closed: number};
  user_registration_process_status: string;

  public static openForTicker(fanMod: FanModerator, match: Match): boolean {
    if (!fanMod.registration_timestamps || !fanMod.registration_timestamps.open || !fanMod.registration_timestamps.closed) {
      return false;
    }

    const now = new Date();
    const openDate = new Date(fanMod.registration_timestamps.open);
    const closedDate = new Date(fanMod.registration_timestamps.closed);
    let matchEnd = null;
    if (match.timestamps.end) { // can be null
      matchEnd = new Date(match.timestamps.end);
    }

    if (openDate < now && now < closedDate && fanMod.status === FanModeratorStatusType.OPEN.value ||
      fanMod.status === FanModeratorStatusType.IMMEDIATE.value && (!matchEnd || now <= matchEnd)) {
      return true;
    }

    return false;
  }

  public constructor(init?: Partial<FanModerator>) {
    Object.assign(this, init);
  }

  public moderatorIsFree(): boolean {
    if (this.status === FanModeratorStatusType.IMMEDIATE.value || this.status === FanModeratorStatusType.OPEN.value) {
      return true;
    }
    return false;
  }

  public atLeastOneFanModeratorRegistered(): boolean {
    if (this.registrations != null && this.registrations.length > 0) {
      return true;
    }
    return false;
  }
}
